/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Network layer service
 */

namespace Application.Services {
    'use strict';

    import BackendService = Services.BackendService;
    import INetworkNodeModem = Models.INetworkNodeModem;
    import NetworkNodeModem = Models.NetworkNodeModem;
    import IHalList = Models.IHalList;
    import HalConverter = Models.HalConverter;
    import IHalElement = Models.IHalElement;
    import IPaginatedList = Models.IPaginatedList;

    /**
     * NetworkNodeModem
     */
    export class NetworkNodeModemService {
        public static $name: string = "networkNodeModemService";
        public static $inject: string[] = ['backendService',
                                           '$q',
                                           ];

        private backendService: BackendService;
        private qService: ng.IQService;
        private backendBaseUrl: string = window.backendUrl;
        private servicePath: string = '';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'networkNodeModems';
        private backendSimUrl: string = this.backendBaseUrl + this.servicePath + 'sims';
        
        constructor(backendService: BackendService, qService: ng.IQService) {
            this.backendService = backendService;
            this.qService = qService;
        }

        public getAllPaginatedNetworkNodeModems(page?: number,
                                                size?: number,
                                                sort?: String): ng.IPromise<IPaginatedList<NetworkNodeModem>> {
            let url: string = this.backendUrl + '?';
            url = page ? url += '&page=' + page : url;
            url = size ? url += '&size=' + size : url;
            url = sort ? url += '&sort=' + sort : url;
            return this.backendService
                .get(url, true)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<NetworkNodeModem>>) => {
                    let convertedList: IPaginatedList<NetworkNodeModem>;
                    convertedList = HalConverter.convertPaginatedList(result.data, NetworkNodeModem.Empty);
                    return convertedList;
                });
        }

        public findByHref(href: string, callback: (result: INetworkNodeModem) => void): void {
            this.getNetworkNodeModemPromise(href)
                .then((element: NetworkNodeModem) => {
                    callback(element);
                }
            );
        }

        public findByHrefPromise(href: string, callback: (result: INetworkNodeModem) => void): ng.IPromise<NetworkNodeModem> {
            return this.getNetworkNodeModemPromise(href);
        }

        public findModemBySimId(simId: number): ng.IPromise<Models.NetworkNodeModemAdapter> {
            let deferred: ng.IDeferred<Models.NetworkNodeModemAdapter> = this.qService.defer();
            let promise: ng.IPromise<Models.INetworkNodeModemAdapter> = deferred.promise;
            this.backendService
                .get(this.backendSimUrl + '/' + simId + '/networkNodeModem', false, undefined, false, false)
                .then((nnm: ng.IHttpPromiseCallbackArg<NetworkNodeModem>) => {
                    this.backendService
                        .get(this.backendBaseUrl + '/networkNodes/' + nnm.data.networkNode)
                        .then((nn: ng.IHttpPromiseCallbackArg<Models.NetworkNode>) => {
                            let nnma: Models.NetworkNodeModemAdapter = new Models.NetworkNodeModemAdapter();
                            nnma.href = nnm.data.href;
                            nnma.imei = nnm.data.imei;
                            nnma.networkNode = nn.data;
                            nnma.slot = nnm.data.slot;
                            deferred.resolve(nnma);
                        })
                        .catch(() => {
                            deferred.resolve(undefined);
                        });
                })
                .catch(() => {
                    deferred.resolve(undefined);
                });
            return promise;
        }

        private getNetworkNodeModemPromise(href: string): ng.IPromise<NetworkNodeModem> {
            return this.backendService
                .get(href)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<NetworkNodeModem>>) => {
                    let halElement: IHalElement<NetworkNodeModem> = data.data;
                    let converted: NetworkNodeModem = HalConverter.convertElement(halElement, NetworkNodeModem.Empty);
                    return converted;
                });
        }
    }
}